export default __webpack_public_path__ + "static/media/axis.ac71ce0b.svg";